import vue from "vue";

export default {
  createYear: ( year ) => vue.axios
              .post("/api/years", { year })
              .catch((error) => {
                return error.response;
              }),

  getYears: () => vue.axios.get("/api/years"),

  createDayOff: ( dayOff ) => vue.axios
              .post("/api/day_off", { day_off: dayOff })
              .catch((error) => {
                return error.response;
              }),

  updateDayOff: ( dayOff ) => vue.axios
              .patch(`/api/day_off/${dayOff.id}`, { day_off: dayOff })
              .catch((error) => {
                return error.response;
              }),

  getDaysOff: () => vue.axios.get(`/api/days_off`),

  isDayOff: (place, date) => vue.axios.get(`api/is_day_off/${place}/${date}`),

  deleteDayOff: (item) => vue.axios.delete(`/api/days_off/${item.id}`)
};
